/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const CollapseIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.71 15.5397L18.36 9.87974C18.4538 9.78677 18.5281 9.67617 18.5789 9.55431C18.6297 9.43246 18.6558 9.30175 18.6558 9.16974C18.6558 9.03773 18.6297 8.90702 18.5789 8.78516C18.5281 8.6633 18.4538 8.5527 18.36 8.45974C18.1727 8.27349 17.9192 8.16895 17.655 8.16895C17.3908 8.16895 17.1374 8.27349 16.95 8.45974L11.95 13.4097L7.00002 8.45974C6.81266 8.27349 6.55921 8.16894 6.29502 8.16894C6.03084 8.16894 5.77739 8.27349 5.59002 8.45974C5.49554 8.55235 5.42037 8.6628 5.36887 8.78467C5.31737 8.90655 5.29057 9.03743 5.29003 9.16974C5.29057 9.30204 5.31737 9.43293 5.36887 9.5548C5.42037 9.67668 5.49554 9.78712 5.59002 9.87974L11.24 15.5397C11.3337 15.6412 11.4473 15.7223 11.5738 15.7777C11.7003 15.8331 11.8369 15.8617 11.975 15.8617C12.1131 15.8617 12.2497 15.8331 12.3762 15.7777C12.5027 15.7223 12.6164 15.6412 12.71 15.5397Z"
        fill="#7E92A2"
      />
    </svg>
  )
}
